import Icon from '__designkit__/icon/Icon';
import V2Button from '__pc__/components/common/v2Design/button';
import V2Icon from '__pc__/components/common/v2Design/icon';
import V2Text from '__pc__/components/common/v2Design/text';
import { V2BackgroundColors } from '__pc__/constant/v2Design/Colors/V2BackgroundColors';
import { SpaceValue } from '__pc__/constant/v2Design/SpaceType';
import { V2ButtonOption } from '__pc__/constant/v2Design/V2ButtonType';
import { V2IconOption } from '__pc__/constant/v2Design/V2IconType';
import { V2TextOption } from '__pc__/constant/v2Design/V2TextType';
import JDFullModal from 'components/_v2/_common/modals/JDFullModal';
import { FC } from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import MatchMessageStore from 'models/MatchMessageStore';
import { injectStore } from 'models/store';
import MatchApplyStatusModel from 'models/_v2/MatchApplyStatusModel';

const Frame = styled.div`
  display: flex;
    flex-direction: column;
    padding:${SpaceValue.XL}px ${SpaceValue.L}px;
    position: relative;
    .close-btn {
        position: absolute;
        text-align: right;
        width: 100%;
        top: 16px;
        right: 16px;
    }
    .title{
        display: flex;
        justify-content: center;
        padding:60px 0 ${SpaceValue.XL}px 0;
    }
    .desc{
        display: flex;
        flex-direction: column;
        padding:${SpaceValue.XL}px ${SpaceValue.L}px;
        background-color: ${V2BackgroundColors.accent_gray_subtle};
        gap:${SpaceValue.L}px;
        .desc-each{
            display: flex;
            gap:${SpaceValue.XS}px;
        }
    }
`;
const BottomButtonFrame = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${V2BackgroundColors.surface_default};
  padding:0 ${SpaceValue.L}px ${SpaceValue.XL}px ${SpaceValue.L}px;
  gap: ${SpaceValue.XS}px;
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom));
    width: 100%;
::before{
  content: '';
  position: absolute;
  top: -24px;
  left: 0;
  width: 100%;
  height: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
}
`;

interface IMatchApplyAcceptModalProps {
  onClickClose: () => void;
  isOpen: boolean;
  matchMessageStore?: MatchMessageStore;
  matchApplyStatusModel?: MatchApplyStatusModel;
}
const MatchApplyAcceptModal:FC<IMatchApplyAcceptModalProps> = ({ onClickClose, isOpen, matchMessageStore = new MatchMessageStore(), matchApplyStatusModel = new MatchApplyStatusModel() }) => {
  const handleClickAccept = async () => {
    await matchMessageStore.acceptMatchHX({ matchingSn: matchMessageStore.matchingSn });
    await matchApplyStatusModel.loadMatchList();
    onClickClose();
  };
  if (!isOpen) return null;
  return (
    <JDFullModal zIndex={10006} isOpen={isOpen}>

      <Frame>
        <Icon name='close' className='close-btn' size={32} onClick={onClickClose} />

        <V2Text fontStyle={V2TextOption.fontStyle.title_2_b} color={V2TextOption.color.default} className='title'>
          제안에 수락하시겠습니까?
        </V2Text>
        <div className='desc'>
          <div className='desc-each'>
            <V2Icon name={V2IconOption.name.check} size={V2IconOption.size.S} />
            <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.default} className='desc-each-text'>
              제안을 수락하면 다음 전형의 최우선 후보자가 됩니다.
            </V2Text>
          </div>
          <div className='desc-each'>
            <V2Icon name={V2IconOption.name.check} size={V2IconOption.size.S} />
            <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.default} className='desc-each-text'>
              현재 시점의 매칭 프로필이 제출되니 최신 정보로 꼭 업데이트하고 수락해 주세요.
            </V2Text>
          </div>
          <div className='desc-each'>
            <V2Icon name={V2IconOption.name.check} size={V2IconOption.size.S} />
            <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.default} className='desc-each-text'>
              다음 전형의 제안에 응답하지 않으면 향후 매칭 우선순위가 변경될 수 있어요.
            </V2Text>
          </div>
          <div className='desc-each'>
            <V2Icon name={V2IconOption.name.check} size={V2IconOption.size.S} />
            <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.default} className='desc-each-text'>
              수락한 제안은 다시 취소할 수 없어요.
            </V2Text>
          </div>
        </div>
      </Frame>
      <BottomButtonFrame>
        <V2Button
          type={V2ButtonOption.type.Fill}
          fontStyle={V2ButtonOption.fontStyle.body_1_sb}
          color={V2ButtonOption.color.inverse}
          fill={V2ButtonOption.fillType.brand_strong_default}
          buttonProps={{ onClick: handleClickAccept }}
        >
          확인
        </V2Button>
      </BottomButtonFrame>
    </JDFullModal>
  );
};

export default inject(injectStore.matchMessageStore, injectStore.matchApplyStatusModel)(observer(MatchApplyAcceptModal));
